import { FC, useState } from 'react';
import { LeftQuoteIcon } from '../theme/Icons';
import { Text } from '../components/Text';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { AsyncStorageProvider } from '../support/AsyncStorageProvider';
import { useAsyncEffect } from '../support/useAsyncEffect';

interface IQuoteConfig {
    text: string;
    author?: string;
    imgFile: string;
}

const quotes: IQuoteConfig[] = [
    { text: 'Caregiving is a constant learning experience.', author: 'Vivian Frazier', imgFile: '1.jpg' },
    { text: 'Caring for others requires caring for oneself.', imgFile: '2.jpg' },
    { text: 'The simple act of caring is heroic.', author: 'Edward Albert', imgFile: '3.jpg' },
    { text: 'You’re making a difference in your loved one’s life every day.', imgFile: '4.jpg' },
    { text: 'You are braver than you believe, stronger than you seem, smarter than you think, and loved more than you know.', author: 'A. A. Milne', imgFile: '5.jpg' },
    { text: 'Even the smallest acts of care have a big impact-remember to celebrate them.', imgFile: '6.jpg' },
    { text: 'It’s okay to ask for help; caregiving is a team effort.', imgFile: '7.jpg' },
    { text: 'Your well-being matters too. Take time to recharge.', author: '', imgFile: '8.jpg' },
    { text: 'Caring for others is an expression of what it means to be human.', imgFile: '9.jpg' },
    { text: 'You are stronger than you know—your care makes a difference.', imgFile: '10.jpg' },
    { text: 'One day at a time, one step at a time—you’re doing amazing.', imgFile: '11.jpg' },
    { text: 'Even on tough days, your love and effort shine through.', imgFile: '12.jpg' },
    { text: 'It’s okay to not have all the answers. You’ve got this.', imgFile: '13.jpg' },
    { text: 'You are doing more than you realize, and it is enough.', imgFile: '14.jpg' },
    { text: 'Life isn’t about waiting for the storm to pass, it’s about learning to dance in the rain.', author: 'Vivian Green', imgFile: '15.jpg' },
];

export const InspirationalQuote: FC = () => {

    const storage = useInstance(AsyncStorageProvider);
    const storageProvider = storage.getJSONProvider<number>('inspirational-quote-index');
    const [quoteIndex, setQuoteIndex] = useState<number>();

    // show the next quote each time the page is loaded
    useAsyncEffect(async () => {
        let index = (await storageProvider.get()) || 0;
        if (index < 0 || index > quotes.length - 1) {
            index = 0;
        }
        setQuoteIndex(index);
        const nextIndex = (index >= quotes.length - 1 ? 0 : index + 1);
        await storageProvider.set(nextIndex);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (quoteIndex === undefined) {
        return null;
    }

    const quote = quotes[quoteIndex];

    return (
        <>
            <img src={`./assets/images/inspiration/${quote.imgFile}`} alt={quote.text} style={{borderRadius: 12}} />

            <div>
                <span style={{lineHeight: 0}}><LeftQuoteIcon size="xlarge" />&nbsp;&nbsp;</span>
                <span>{quote.text}</span>
            </div>

            <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 4}}>
                {quote.author &&
                    <Text><b style={{fontSize: 14}}>– {quote.author}</b></Text>
                }
            </div>
        </>
    );
};
